import { isVue3 as Dt } from "vue-demi";
var at = typeof global == "object" && global && global.Object === Object && global, Nt = typeof self == "object" && self && self.Object === Object && self, S = at || Nt || Function("return this")(), m = S.Symbol, ot = Object.prototype, Ut = ot.hasOwnProperty, Gt = ot.toString, G = m ? m.toStringTag : void 0;
function Bt(e) {
  var t = Ut.call(e, G), r = e[G];
  try {
    e[G] = void 0;
    var n = !0;
  } catch {
  }
  var a = Gt.call(e);
  return n && (t ? e[G] = r : delete e[G]), a;
}
var Ht = Object.prototype, zt = Ht.toString;
function Kt(e) {
  return zt.call(e);
}
var Wt = "[object Null]", Xt = "[object Undefined]", xe = m ? m.toStringTag : void 0;
function C(e) {
  return e == null ? e === void 0 ? Xt : Wt : xe && xe in Object(e) ? Bt(e) : Kt(e);
}
function P(e) {
  return e != null && typeof e == "object";
}
var qt = "[object Symbol]";
function he(e) {
  return typeof e == "symbol" || P(e) && C(e) == qt;
}
function Yt(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = Array(n); ++r < n; )
    a[r] = t(e[r], r, e);
  return a;
}
var A = Array.isArray, Zt = 1 / 0, Ie = m ? m.prototype : void 0, je = Ie ? Ie.toString : void 0;
function st(e) {
  if (typeof e == "string")
    return e;
  if (A(e))
    return Yt(e, st) + "";
  if (he(e))
    return je ? je.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -Zt ? "-0" : t;
}
function E(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
function ye(e) {
  return e;
}
var Jt = "[object AsyncFunction]", Qt = "[object Function]", Vt = "[object GeneratorFunction]", kt = "[object Proxy]";
function be(e) {
  if (!E(e))
    return !1;
  var t = C(e);
  return t == Qt || t == Vt || t == Jt || t == kt;
}
var ae = S["__core-js_shared__"], Ce = function() {
  var e = /[^.]+$/.exec(ae && ae.keys && ae.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function er(e) {
  return !!Ce && Ce in e;
}
var tr = Function.prototype, rr = tr.toString;
function L(e) {
  if (e != null) {
    try {
      return rr.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var nr = /[\\^$.*+?()[\]{}|]/g, ir = /^\[object .+?Constructor\]$/, ar = Function.prototype, or = Object.prototype, sr = ar.toString, fr = or.hasOwnProperty, ur = RegExp(
  "^" + sr.call(fr).replace(nr, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function cr(e) {
  if (!E(e) || er(e))
    return !1;
  var t = be(e) ? ur : ir;
  return t.test(L(e));
}
function lr(e, t) {
  return e == null ? void 0 : e[t];
}
function M(e, t) {
  var r = lr(e, t);
  return cr(r) ? r : void 0;
}
var fe = M(S, "WeakMap"), Le = Object.create, pr = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!E(t))
      return {};
    if (Le)
      return Le(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}();
function gr(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
function ft(e, t) {
  var r = -1, n = e.length;
  for (t || (t = Array(n)); ++r < n; )
    t[r] = e[r];
  return t;
}
var dr = 800, hr = 16, yr = Date.now;
function br(e) {
  var t = 0, r = 0;
  return function() {
    var n = yr(), a = hr - (n - r);
    if (r = n, a > 0) {
      if (++t >= dr)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function vr(e) {
  return function() {
    return e;
  };
}
var J = function() {
  try {
    var e = M(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), _r = J ? function(e, t) {
  return J(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: vr(t),
    writable: !0
  });
} : ye, Tr = br(_r);
function Ar(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n && t(e[r], r, e) !== !1; )
    ;
  return e;
}
var $r = 9007199254740991, Or = /^(?:0|[1-9]\d*)$/;
function ve(e, t) {
  var r = typeof e;
  return t = t ?? $r, !!t && (r == "number" || r != "symbol" && Or.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function ee(e, t, r) {
  t == "__proto__" && J ? J(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
function X(e, t) {
  return e === t || e !== e && t !== t;
}
var wr = Object.prototype, mr = wr.hasOwnProperty;
function ut(e, t, r) {
  var n = e[t];
  (!(mr.call(e, t) && X(n, r)) || r === void 0 && !(t in e)) && ee(e, t, r);
}
function D(e, t, r, n) {
  var a = !r;
  r || (r = {});
  for (var i = -1, o = t.length; ++i < o; ) {
    var s = t[i], f = n ? n(r[s], e[s], s, r, e) : void 0;
    f === void 0 && (f = e[s]), a ? ee(r, s, f) : ut(r, s, f);
  }
  return r;
}
var Me = Math.max;
function Pr(e, t, r) {
  return t = Me(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, a = -1, i = Me(n.length - t, 0), o = Array(i); ++a < i; )
      o[a] = n[t + a];
    a = -1;
    for (var s = Array(t + 1); ++a < t; )
      s[a] = n[a];
    return s[t] = r(o), gr(e, this, s);
  };
}
function Sr(e, t) {
  return Tr(Pr(e, t, ye), e + "");
}
var Er = 9007199254740991;
function _e(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Er;
}
function te(e) {
  return e != null && _e(e.length) && !be(e);
}
function xr(e, t, r) {
  if (!E(r))
    return !1;
  var n = typeof t;
  return (n == "number" ? te(r) && ve(t, r.length) : n == "string" && t in r) ? X(r[t], e) : !1;
}
function ct(e) {
  return Sr(function(t, r) {
    var n = -1, a = r.length, i = a > 1 ? r[a - 1] : void 0, o = a > 2 ? r[2] : void 0;
    for (i = e.length > 3 && typeof i == "function" ? (a--, i) : void 0, o && xr(r[0], r[1], o) && (i = a < 3 ? void 0 : i, a = 1), t = Object(t); ++n < a; ) {
      var s = r[n];
      s && e(t, s, n, i);
    }
    return t;
  });
}
var Ir = Object.prototype;
function Te(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || Ir;
  return e === r;
}
function jr(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var Cr = "[object Arguments]";
function Re(e) {
  return P(e) && C(e) == Cr;
}
var lt = Object.prototype, Lr = lt.hasOwnProperty, Mr = lt.propertyIsEnumerable, Q = Re(/* @__PURE__ */ function() {
  return arguments;
}()) ? Re : function(e) {
  return P(e) && Lr.call(e, "callee") && !Mr.call(e, "callee");
};
function Rr() {
  return !1;
}
var pt = typeof exports == "object" && exports && !exports.nodeType && exports, Fe = pt && typeof module == "object" && module && !module.nodeType && module, Fr = Fe && Fe.exports === pt, De = Fr ? S.Buffer : void 0, Dr = De ? De.isBuffer : void 0, z = Dr || Rr, Nr = "[object Arguments]", Ur = "[object Array]", Gr = "[object Boolean]", Br = "[object Date]", Hr = "[object Error]", zr = "[object Function]", Kr = "[object Map]", Wr = "[object Number]", Xr = "[object Object]", qr = "[object RegExp]", Yr = "[object Set]", Zr = "[object String]", Jr = "[object WeakMap]", Qr = "[object ArrayBuffer]", Vr = "[object DataView]", kr = "[object Float32Array]", en = "[object Float64Array]", tn = "[object Int8Array]", rn = "[object Int16Array]", nn = "[object Int32Array]", an = "[object Uint8Array]", on = "[object Uint8ClampedArray]", sn = "[object Uint16Array]", fn = "[object Uint32Array]", h = {};
h[kr] = h[en] = h[tn] = h[rn] = h[nn] = h[an] = h[on] = h[sn] = h[fn] = !0;
h[Nr] = h[Ur] = h[Qr] = h[Gr] = h[Vr] = h[Br] = h[Hr] = h[zr] = h[Kr] = h[Wr] = h[Xr] = h[qr] = h[Yr] = h[Zr] = h[Jr] = !1;
function un(e) {
  return P(e) && _e(e.length) && !!h[C(e)];
}
function Ae(e) {
  return function(t) {
    return e(t);
  };
}
var gt = typeof exports == "object" && exports && !exports.nodeType && exports, B = gt && typeof module == "object" && module && !module.nodeType && module, cn = B && B.exports === gt, oe = cn && at.process, F = function() {
  try {
    var e = B && B.require && B.require("util").types;
    return e || oe && oe.binding && oe.binding("util");
  } catch {
  }
}(), Ne = F && F.isTypedArray, $e = Ne ? Ae(Ne) : un, ln = Object.prototype, pn = ln.hasOwnProperty;
function dt(e, t) {
  var r = A(e), n = !r && Q(e), a = !r && !n && z(e), i = !r && !n && !a && $e(e), o = r || n || a || i, s = o ? jr(e.length, String) : [], f = s.length;
  for (var u in e)
    (t || pn.call(e, u)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    ve(u, f))) && s.push(u);
  return s;
}
function ht(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var gn = ht(Object.keys, Object), dn = Object.prototype, hn = dn.hasOwnProperty;
function yn(e) {
  if (!Te(e))
    return gn(e);
  var t = [];
  for (var r in Object(e))
    hn.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function q(e) {
  return te(e) ? dt(e) : yn(e);
}
function bn(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var vn = Object.prototype, _n = vn.hasOwnProperty;
function Tn(e) {
  if (!E(e))
    return bn(e);
  var t = Te(e), r = [];
  for (var n in e)
    n == "constructor" && (t || !_n.call(e, n)) || r.push(n);
  return r;
}
function N(e) {
  return te(e) ? dt(e, !0) : Tn(e);
}
var An = ct(function(e, t, r, n) {
  D(t, N(t), e, n);
}), $n = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, On = /^\w*$/;
function Oe(e, t) {
  if (A(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || he(e) ? !0 : On.test(e) || !$n.test(e) || t != null && e in Object(t);
}
var K = M(Object, "create");
function wn() {
  this.__data__ = K ? K(null) : {}, this.size = 0;
}
function mn(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Pn = "__lodash_hash_undefined__", Sn = Object.prototype, En = Sn.hasOwnProperty;
function xn(e) {
  var t = this.__data__;
  if (K) {
    var r = t[e];
    return r === Pn ? void 0 : r;
  }
  return En.call(t, e) ? t[e] : void 0;
}
var In = Object.prototype, jn = In.hasOwnProperty;
function Cn(e) {
  var t = this.__data__;
  return K ? t[e] !== void 0 : jn.call(t, e);
}
var Ln = "__lodash_hash_undefined__";
function Mn(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = K && t === void 0 ? Ln : t, this;
}
function j(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
j.prototype.clear = wn;
j.prototype.delete = mn;
j.prototype.get = xn;
j.prototype.has = Cn;
j.prototype.set = Mn;
function Rn() {
  this.__data__ = [], this.size = 0;
}
function re(e, t) {
  for (var r = e.length; r--; )
    if (X(e[r][0], t))
      return r;
  return -1;
}
var Fn = Array.prototype, Dn = Fn.splice;
function Nn(e) {
  var t = this.__data__, r = re(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : Dn.call(t, r, 1), --this.size, !0;
}
function Un(e) {
  var t = this.__data__, r = re(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function Gn(e) {
  return re(this.__data__, e) > -1;
}
function Bn(e, t) {
  var r = this.__data__, n = re(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function x(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
x.prototype.clear = Rn;
x.prototype.delete = Nn;
x.prototype.get = Un;
x.prototype.has = Gn;
x.prototype.set = Bn;
var W = M(S, "Map");
function Hn() {
  this.size = 0, this.__data__ = {
    hash: new j(),
    map: new (W || x)(),
    string: new j()
  };
}
function zn(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function ne(e, t) {
  var r = e.__data__;
  return zn(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function Kn(e) {
  var t = ne(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function Wn(e) {
  return ne(this, e).get(e);
}
function Xn(e) {
  return ne(this, e).has(e);
}
function qn(e, t) {
  var r = ne(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function I(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
I.prototype.clear = Hn;
I.prototype.delete = Kn;
I.prototype.get = Wn;
I.prototype.has = Xn;
I.prototype.set = qn;
var Yn = "Expected a function";
function we(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Yn);
  var r = function() {
    var n = arguments, a = t ? t.apply(this, n) : n[0], i = r.cache;
    if (i.has(a))
      return i.get(a);
    var o = e.apply(this, n);
    return r.cache = i.set(a, o) || i, o;
  };
  return r.cache = new (we.Cache || I)(), r;
}
we.Cache = I;
var Zn = 500;
function Jn(e) {
  var t = we(e, function(n) {
    return r.size === Zn && r.clear(), n;
  }), r = t.cache;
  return t;
}
var Qn = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Vn = /\\(\\)?/g, kn = Jn(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Qn, function(r, n, a, i) {
    t.push(a ? i.replace(Vn, "$1") : n || r);
  }), t;
});
function ei(e) {
  return e == null ? "" : st(e);
}
function yt(e, t) {
  return A(e) ? e : Oe(e, t) ? [e] : kn(ei(e));
}
var ti = 1 / 0;
function ie(e) {
  if (typeof e == "string" || he(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -ti ? "-0" : t;
}
function bt(e, t) {
  t = yt(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[ie(t[r++])];
  return r && r == n ? e : void 0;
}
function ri(e, t, r) {
  var n = e == null ? void 0 : bt(e, t);
  return n === void 0 ? r : n;
}
function vt(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
var me = ht(Object.getPrototypeOf, Object), ni = "[object Object]", ii = Function.prototype, ai = Object.prototype, _t = ii.toString, oi = ai.hasOwnProperty, si = _t.call(Object);
function fi(e) {
  if (!P(e) || C(e) != ni)
    return !1;
  var t = me(e);
  if (t === null)
    return !0;
  var r = oi.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && _t.call(r) == si;
}
function ui() {
  this.__data__ = new x(), this.size = 0;
}
function ci(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
function li(e) {
  return this.__data__.get(e);
}
function pi(e) {
  return this.__data__.has(e);
}
var gi = 200;
function di(e, t) {
  var r = this.__data__;
  if (r instanceof x) {
    var n = r.__data__;
    if (!W || n.length < gi - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new I(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
function w(e) {
  var t = this.__data__ = new x(e);
  this.size = t.size;
}
w.prototype.clear = ui;
w.prototype.delete = ci;
w.prototype.get = li;
w.prototype.has = pi;
w.prototype.set = di;
function hi(e, t) {
  return e && D(t, q(t), e);
}
function yi(e, t) {
  return e && D(t, N(t), e);
}
var Tt = typeof exports == "object" && exports && !exports.nodeType && exports, Ue = Tt && typeof module == "object" && module && !module.nodeType && module, bi = Ue && Ue.exports === Tt, Ge = bi ? S.Buffer : void 0, Be = Ge ? Ge.allocUnsafe : void 0;
function At(e, t) {
  if (t)
    return e.slice();
  var r = e.length, n = Be ? Be(r) : new e.constructor(r);
  return e.copy(n), n;
}
function vi(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, i = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (i[a++] = o);
  }
  return i;
}
function $t() {
  return [];
}
var _i = Object.prototype, Ti = _i.propertyIsEnumerable, He = Object.getOwnPropertySymbols, Pe = He ? function(e) {
  return e == null ? [] : (e = Object(e), vi(He(e), function(t) {
    return Ti.call(e, t);
  }));
} : $t;
function Ai(e, t) {
  return D(e, Pe(e), t);
}
var $i = Object.getOwnPropertySymbols, Ot = $i ? function(e) {
  for (var t = []; e; )
    vt(t, Pe(e)), e = me(e);
  return t;
} : $t;
function Oi(e, t) {
  return D(e, Ot(e), t);
}
function wt(e, t, r) {
  var n = t(e);
  return A(e) ? n : vt(n, r(e));
}
function ue(e) {
  return wt(e, q, Pe);
}
function wi(e) {
  return wt(e, N, Ot);
}
var ce = M(S, "DataView"), le = M(S, "Promise"), pe = M(S, "Set"), ze = "[object Map]", mi = "[object Object]", Ke = "[object Promise]", We = "[object Set]", Xe = "[object WeakMap]", qe = "[object DataView]", Pi = L(ce), Si = L(W), Ei = L(le), xi = L(pe), Ii = L(fe), O = C;
(ce && O(new ce(new ArrayBuffer(1))) != qe || W && O(new W()) != ze || le && O(le.resolve()) != Ke || pe && O(new pe()) != We || fe && O(new fe()) != Xe) && (O = function(e) {
  var t = C(e), r = t == mi ? e.constructor : void 0, n = r ? L(r) : "";
  if (n)
    switch (n) {
      case Pi:
        return qe;
      case Si:
        return ze;
      case Ei:
        return Ke;
      case xi:
        return We;
      case Ii:
        return Xe;
    }
  return t;
});
var ji = Object.prototype, Ci = ji.hasOwnProperty;
function Li(e) {
  var t = e.length, r = new e.constructor(t);
  return t && typeof e[0] == "string" && Ci.call(e, "index") && (r.index = e.index, r.input = e.input), r;
}
var V = S.Uint8Array;
function Se(e) {
  var t = new e.constructor(e.byteLength);
  return new V(t).set(new V(e)), t;
}
function Mi(e, t) {
  var r = t ? Se(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.byteLength);
}
var Ri = /\w*$/;
function Fi(e) {
  var t = new e.constructor(e.source, Ri.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var Ye = m ? m.prototype : void 0, Ze = Ye ? Ye.valueOf : void 0;
function Di(e) {
  return Ze ? Object(Ze.call(e)) : {};
}
function mt(e, t) {
  var r = t ? Se(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var Ni = "[object Boolean]", Ui = "[object Date]", Gi = "[object Map]", Bi = "[object Number]", Hi = "[object RegExp]", zi = "[object Set]", Ki = "[object String]", Wi = "[object Symbol]", Xi = "[object ArrayBuffer]", qi = "[object DataView]", Yi = "[object Float32Array]", Zi = "[object Float64Array]", Ji = "[object Int8Array]", Qi = "[object Int16Array]", Vi = "[object Int32Array]", ki = "[object Uint8Array]", ea = "[object Uint8ClampedArray]", ta = "[object Uint16Array]", ra = "[object Uint32Array]";
function na(e, t, r) {
  var n = e.constructor;
  switch (t) {
    case Xi:
      return Se(e);
    case Ni:
    case Ui:
      return new n(+e);
    case qi:
      return Mi(e, r);
    case Yi:
    case Zi:
    case Ji:
    case Qi:
    case Vi:
    case ki:
    case ea:
    case ta:
    case ra:
      return mt(e, r);
    case Gi:
      return new n();
    case Bi:
    case Ki:
      return new n(e);
    case Hi:
      return Fi(e);
    case zi:
      return new n();
    case Wi:
      return Di(e);
  }
}
function Pt(e) {
  return typeof e.constructor == "function" && !Te(e) ? pr(me(e)) : {};
}
var ia = "[object Map]";
function aa(e) {
  return P(e) && O(e) == ia;
}
var Je = F && F.isMap, oa = Je ? Ae(Je) : aa, sa = "[object Set]";
function fa(e) {
  return P(e) && O(e) == sa;
}
var Qe = F && F.isSet, ua = Qe ? Ae(Qe) : fa, ca = 1, la = 2, pa = 4, St = "[object Arguments]", ga = "[object Array]", da = "[object Boolean]", ha = "[object Date]", ya = "[object Error]", Et = "[object Function]", ba = "[object GeneratorFunction]", va = "[object Map]", _a = "[object Number]", xt = "[object Object]", Ta = "[object RegExp]", Aa = "[object Set]", $a = "[object String]", Oa = "[object Symbol]", wa = "[object WeakMap]", ma = "[object ArrayBuffer]", Pa = "[object DataView]", Sa = "[object Float32Array]", Ea = "[object Float64Array]", xa = "[object Int8Array]", Ia = "[object Int16Array]", ja = "[object Int32Array]", Ca = "[object Uint8Array]", La = "[object Uint8ClampedArray]", Ma = "[object Uint16Array]", Ra = "[object Uint32Array]", g = {};
g[St] = g[ga] = g[ma] = g[Pa] = g[da] = g[ha] = g[Sa] = g[Ea] = g[xa] = g[Ia] = g[ja] = g[va] = g[_a] = g[xt] = g[Ta] = g[Aa] = g[$a] = g[Oa] = g[Ca] = g[La] = g[Ma] = g[Ra] = !0;
g[ya] = g[Et] = g[wa] = !1;
function Z(e, t, r, n, a, i) {
  var o, s = t & ca, f = t & la, u = t & pa;
  if (o !== void 0)
    return o;
  if (!E(e))
    return e;
  var c = A(e);
  if (c) {
    if (o = Li(e), !s)
      return ft(e, o);
  } else {
    var l = O(e), p = l == Et || l == ba;
    if (z(e))
      return At(e, s);
    if (l == xt || l == St || p && !a) {
      if (o = f || p ? {} : Pt(e), !s)
        return f ? Oi(e, yi(o, e)) : Ai(e, hi(o, e));
    } else {
      if (!g[l])
        return a ? e : {};
      o = na(e, l, s);
    }
  }
  i || (i = new w());
  var y = i.get(e);
  if (y)
    return y;
  i.set(e, o), ua(e) ? e.forEach(function(v) {
    o.add(Z(v, t, r, v, e, i));
  }) : oa(e) && e.forEach(function(v, _) {
    o.set(_, Z(v, t, r, _, e, i));
  });
  var d = u ? f ? wi : ue : f ? N : q, T = c ? void 0 : d(e);
  return Ar(T || e, function(v, _) {
    T && (_ = v, v = e[_]), ut(o, _, Z(v, t, r, _, e, i));
  }), o;
}
var Fa = 1, Da = 4;
function Na(e) {
  return Z(e, Fa | Da);
}
var Ua = "__lodash_hash_undefined__";
function Ga(e) {
  return this.__data__.set(e, Ua), this;
}
function Ba(e) {
  return this.__data__.has(e);
}
function k(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new I(); ++t < r; )
    this.add(e[t]);
}
k.prototype.add = k.prototype.push = Ga;
k.prototype.has = Ba;
function Ha(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
function za(e, t) {
  return e.has(t);
}
var Ka = 1, Wa = 2;
function It(e, t, r, n, a, i) {
  var o = r & Ka, s = e.length, f = t.length;
  if (s != f && !(o && f > s))
    return !1;
  var u = i.get(e), c = i.get(t);
  if (u && c)
    return u == t && c == e;
  var l = -1, p = !0, y = r & Wa ? new k() : void 0;
  for (i.set(e, t), i.set(t, e); ++l < s; ) {
    var d = e[l], T = t[l];
    if (n)
      var v = o ? n(T, d, l, t, e, i) : n(d, T, l, e, t, i);
    if (v !== void 0) {
      if (v)
        continue;
      p = !1;
      break;
    }
    if (y) {
      if (!Ha(t, function(_, b) {
        if (!za(y, b) && (d === _ || a(d, _, r, n, i)))
          return y.push(b);
      })) {
        p = !1;
        break;
      }
    } else if (!(d === T || a(d, T, r, n, i))) {
      p = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), p;
}
function Xa(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
function qa(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var Ya = 1, Za = 2, Ja = "[object Boolean]", Qa = "[object Date]", Va = "[object Error]", ka = "[object Map]", eo = "[object Number]", to = "[object RegExp]", ro = "[object Set]", no = "[object String]", io = "[object Symbol]", ao = "[object ArrayBuffer]", oo = "[object DataView]", Ve = m ? m.prototype : void 0, se = Ve ? Ve.valueOf : void 0;
function so(e, t, r, n, a, i, o) {
  switch (r) {
    case oo:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case ao:
      return !(e.byteLength != t.byteLength || !i(new V(e), new V(t)));
    case Ja:
    case Qa:
    case eo:
      return X(+e, +t);
    case Va:
      return e.name == t.name && e.message == t.message;
    case to:
    case no:
      return e == t + "";
    case ka:
      var s = Xa;
    case ro:
      var f = n & Ya;
      if (s || (s = qa), e.size != t.size && !f)
        return !1;
      var u = o.get(e);
      if (u)
        return u == t;
      n |= Za, o.set(e, t);
      var c = It(s(e), s(t), n, a, i, o);
      return o.delete(e), c;
    case io:
      if (se)
        return se.call(e) == se.call(t);
  }
  return !1;
}
var fo = 1, uo = Object.prototype, co = uo.hasOwnProperty;
function lo(e, t, r, n, a, i) {
  var o = r & fo, s = ue(e), f = s.length, u = ue(t), c = u.length;
  if (f != c && !o)
    return !1;
  for (var l = f; l--; ) {
    var p = s[l];
    if (!(o ? p in t : co.call(t, p)))
      return !1;
  }
  var y = i.get(e), d = i.get(t);
  if (y && d)
    return y == t && d == e;
  var T = !0;
  i.set(e, t), i.set(t, e);
  for (var v = o; ++l < f; ) {
    p = s[l];
    var _ = e[p], b = t[p];
    if (n)
      var $ = o ? n(b, _, p, t, e, i) : n(_, b, p, e, t, i);
    if (!($ === void 0 ? _ === b || a(_, b, r, n, i) : $)) {
      T = !1;
      break;
    }
    v || (v = p == "constructor");
  }
  if (T && !v) {
    var R = e.constructor, U = t.constructor;
    R != U && "constructor" in e && "constructor" in t && !(typeof R == "function" && R instanceof R && typeof U == "function" && U instanceof U) && (T = !1);
  }
  return i.delete(e), i.delete(t), T;
}
var po = 1, ke = "[object Arguments]", et = "[object Array]", Y = "[object Object]", go = Object.prototype, tt = go.hasOwnProperty;
function ho(e, t, r, n, a, i) {
  var o = A(e), s = A(t), f = o ? et : O(e), u = s ? et : O(t);
  f = f == ke ? Y : f, u = u == ke ? Y : u;
  var c = f == Y, l = u == Y, p = f == u;
  if (p && z(e)) {
    if (!z(t))
      return !1;
    o = !0, c = !1;
  }
  if (p && !c)
    return i || (i = new w()), o || $e(e) ? It(e, t, r, n, a, i) : so(e, t, f, r, n, a, i);
  if (!(r & po)) {
    var y = c && tt.call(e, "__wrapped__"), d = l && tt.call(t, "__wrapped__");
    if (y || d) {
      var T = y ? e.value() : e, v = d ? t.value() : t;
      return i || (i = new w()), a(T, v, r, n, i);
    }
  }
  return p ? (i || (i = new w()), lo(e, t, r, n, a, i)) : !1;
}
function Ee(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !P(e) && !P(t) ? e !== e && t !== t : ho(e, t, r, n, Ee, a);
}
var yo = 1, bo = 2;
function vo(e, t, r, n) {
  var a = r.length, i = a;
  if (e == null)
    return !i;
  for (e = Object(e); a--; ) {
    var o = r[a];
    if (o[2] ? o[1] !== e[o[0]] : !(o[0] in e))
      return !1;
  }
  for (; ++a < i; ) {
    o = r[a];
    var s = o[0], f = e[s], u = o[1];
    if (o[2]) {
      if (f === void 0 && !(s in e))
        return !1;
    } else {
      var c = new w(), l;
      if (!(l === void 0 ? Ee(u, f, yo | bo, n, c) : l))
        return !1;
    }
  }
  return !0;
}
function jt(e) {
  return e === e && !E(e);
}
function _o(e) {
  for (var t = q(e), r = t.length; r--; ) {
    var n = t[r], a = e[n];
    t[r] = [n, a, jt(a)];
  }
  return t;
}
function Ct(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
function To(e) {
  var t = _o(e);
  return t.length == 1 && t[0][2] ? Ct(t[0][0], t[0][1]) : function(r) {
    return r === e || vo(r, e, t);
  };
}
function Ao(e, t) {
  return e != null && t in Object(e);
}
function $o(e, t, r) {
  t = yt(t, e);
  for (var n = -1, a = t.length, i = !1; ++n < a; ) {
    var o = ie(t[n]);
    if (!(i = e != null && r(e, o)))
      break;
    e = e[o];
  }
  return i || ++n != a ? i : (a = e == null ? 0 : e.length, !!a && _e(a) && ve(o, a) && (A(e) || Q(e)));
}
function Oo(e, t) {
  return e != null && $o(e, t, Ao);
}
var wo = 1, mo = 2;
function Po(e, t) {
  return Oe(e) && jt(t) ? Ct(ie(e), t) : function(r) {
    var n = ri(r, e);
    return n === void 0 && n === t ? Oo(r, e) : Ee(t, n, wo | mo);
  };
}
function So(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function Eo(e) {
  return function(t) {
    return bt(t, e);
  };
}
function xo(e) {
  return Oe(e) ? So(ie(e)) : Eo(e);
}
function Io(e) {
  return typeof e == "function" ? e : e == null ? ye : typeof e == "object" ? A(e) ? Po(e[0], e[1]) : To(e) : xo(e);
}
function jo(e) {
  return function(t, r, n) {
    for (var a = -1, i = Object(t), o = n(t), s = o.length; s--; ) {
      var f = o[++a];
      if (r(i[f], f, i) === !1)
        break;
    }
    return t;
  };
}
var Lt = jo();
function Co(e, t) {
  return e && Lt(e, t, q);
}
function ge(e, t, r) {
  (r !== void 0 && !X(e[t], r) || r === void 0 && !(t in e)) && ee(e, t, r);
}
function Lo(e) {
  return P(e) && te(e);
}
function de(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
function Mo(e) {
  return D(e, N(e));
}
function Ro(e, t, r, n, a, i, o) {
  var s = de(e, r), f = de(t, r), u = o.get(f);
  if (u) {
    ge(e, r, u);
    return;
  }
  var c = i ? i(s, f, r + "", e, t, o) : void 0, l = c === void 0;
  if (l) {
    var p = A(f), y = !p && z(f), d = !p && !y && $e(f);
    c = f, p || y || d ? A(s) ? c = s : Lo(s) ? c = ft(s) : y ? (l = !1, c = At(f, !0)) : d ? (l = !1, c = mt(f, !0)) : c = [] : fi(f) || Q(f) ? (c = s, Q(s) ? c = Mo(s) : (!E(s) || be(s)) && (c = Pt(f))) : l = !1;
  }
  l && (o.set(f, c), a(c, f, n, i, o), o.delete(f)), ge(e, r, c);
}
function Mt(e, t, r, n, a) {
  e !== t && Lt(t, function(i, o) {
    if (a || (a = new w()), E(i))
      Ro(e, t, o, r, Mt, n, a);
    else {
      var s = n ? n(de(e, o), i, o + "", e, t, a) : void 0;
      s === void 0 && (s = i), ge(e, o, s);
    }
  }, N);
}
var Fo = ct(function(e, t, r, n) {
  Mt(e, t, r, n);
});
function Do(e, t) {
  var r = {};
  return t = Io(t), Co(e, function(n, a, i) {
    ee(r, t(n, a, i), n);
  }), r;
}
const No = new RegExp("([\\p{Ll}\\d])(\\p{Lu})", "gu"), Uo = new RegExp("(\\p{Lu})([\\p{Lu}][\\p{Ll}])", "gu"), Go = new RegExp("(\\d)\\p{Ll}|(\\p{L})\\d", "u"), Bo = /[^\p{L}\d]+/giu, rt = "$1\0$2", nt = "";
function Rt(e) {
  let t = e.trim();
  t = t.replace(No, rt).replace(Uo, rt), t = t.replace(Bo, "\0");
  let r = 0, n = t.length;
  for (; t.charAt(r) === "\0"; )
    r++;
  if (r === n)
    return [];
  for (; t.charAt(n - 1) === "\0"; )
    n--;
  return t.slice(r, n).split(/\0/g);
}
function Ho(e) {
  const t = Rt(e);
  for (let r = 0; r < t.length; r++) {
    const n = t[r], a = Go.exec(n);
    if (a) {
      const i = a.index + (a[1] ?? a[2]).length;
      t.splice(r, 1, n.slice(0, i), n.slice(i));
    }
  }
  return t;
}
function zo(e, t) {
  const [r, n, a] = qo(e, t), i = Ko(t == null ? void 0 : t.locale), o = Wo(t == null ? void 0 : t.locale), s = Xo(i, o);
  return r + n.map((f, u) => u === 0 ? i(f) : s(f, u)).join("") + a;
}
function Ko(e) {
  return (t) => t.toLocaleLowerCase(e);
}
function Wo(e) {
  return (t) => t.toLocaleUpperCase(e);
}
function Xo(e, t) {
  return (r, n) => {
    const a = r[0];
    return (n > 0 && a >= "0" && a <= "9" ? "_" + a : t(a)) + e(r.slice(1));
  };
}
function qo(e, t = {}) {
  const r = t.split ?? (t.separateNumbers ? Ho : Rt), n = t.prefixCharacters ?? nt, a = t.suffixCharacters ?? nt;
  let i = 0, o = e.length;
  for (; i < e.length; ) {
    const s = e.charAt(i);
    if (!n.includes(s))
      break;
    i++;
  }
  for (; o > i; ) {
    const s = o - 1, f = e.charAt(s);
    if (!a.includes(f))
      break;
    o = s;
  }
  return [
    e.slice(0, i),
    r(e.slice(i, o)),
    e.slice(o)
  ];
}
const H = (e) => /.+-.+/.test(e) ? zo(e) : e, Yo = (e) => Object.prototype.toString.call(e).slice(8, -1) === "Object";
function Zo(e, t) {
  const r = /* @__PURE__ */ Object.create(null), n = e.split(",");
  for (let a = 0; a < n.length; a++)
    r[n[a]] = !0;
  return (a) => !!r[a];
}
const Jo = /* @__PURE__ */ Zo("String,Number,Boolean,Function,Symbol,BigInt");
function Qo(e) {
  const t = e == null ? void 0 : e.toString().match(/^\s*function (\w+)/);
  return t ? t[1] : e === null ? "null" : "";
}
function Vo(e, t) {
  let r;
  const n = Qo(t);
  if (Jo(n)) {
    const a = typeof e;
    r = a === n.toLowerCase(), !r && a === "object" && (r = e instanceof t);
  } else n === "Object" ? r = E(e) : n === "Array" ? r = Array.isArray(e) : n === "null" ? r = e === null : r = e instanceof t;
  return {
    valid: r,
    expectedType: n
  };
}
function ko({
  prop: e,
  type: t,
  validator: r
}) {
  if (![void 0, null].includes(e) && t) {
    let n = !1;
    const a = Array.isArray(t) ? t : [t], i = [];
    for (let o = 0; o < a.length && !n; o++) {
      const { valid: s, expectedType: f } = Vo(e, a[o]);
      i.push(f || ""), n = s;
    }
    if (!n)
      throw new TypeError(
        `Invalid prop: type check failed, expecting [${i.join(
          ", "
        )}], receiving: ${e}`
      );
  }
  if (r && !r(e))
    throw new Error(`Invalid prop: validator check failed, receiving: ${e}`);
}
function es(e, {
  mergeObject: t,
  mergeObjectCustomizer: r,
  mergeFunction: n
}) {
  const a = [];
  for (let o = e.length - 1; o >= 0; o--)
    a.push(e[o]);
  const i = r || (n ? (o, s) => typeof o == "function" && typeof s == "function" ? n == null ? void 0 : n(s, o) : void 0 : void 0);
  return t === "deep" ? Fo(...a, i) : An(...a, i);
}
function ts(e, {
  mergeFunction: t
}) {
  return e.reduce(t, () => {
  });
}
function rs(e, t = {}) {
  const {
    type: r,
    default: n,
    defaultIsDynamic: a = !1,
    required: i = !1,
    validator: o,
    camelizeObjectKeys: s = !1,
    mergeObjectApplyOnlyToDefault: f = !1,
    mergeFunctionApplyOnlyToDefault: u = !0
  } = t;
  let { mergeObject: c = "deep", mergeObjectCustomizer: l, mergeFunction: p = !1 } = t;
  const y = [];
  let d, T = !1, v = !1;
  const _ = (b) => {
    if (b !== void 0) {
      ko({ type: r, prop: b, validator: o });
      const $ = Yo(b), R = typeof b == "function";
      return T = $, v = R, $ ? (b = Na(b), s ? Do(b, (U, Ft) => H(Ft)) : b) : b;
    }
  };
  for (const b of e)
    y.push(_(b));
  if (!a)
    y.push(_(n));
  else if (typeof n != "function")
    throw new TypeError(
      `Invalid option: options.default should be Function when options.defaultIsDynamic enabled, receiving: ${n}`
    );
  T || (c = !1, v || (p = !1));
  for (let b = 0; b < y.length; b++) {
    const $ = y[b];
    if ($ !== void 0) {
      b === y.length - 1 ? d = $ : c ? d = es(
        f ? [$, n] : y,
        {
          mergeObject: c,
          mergeObjectCustomizer: l,
          mergeFunction: p
        }
      ) : p ? d = ts(
        u ? [$, n] : y,
        {
          mergeFunction: p
        }
      ) : d = $;
      break;
    }
  }
  if (i && [void 0, null].includes(d))
    throw new Error("Missing required prop");
  return a ? rs(e, {
    ...t,
    default: n(d),
    defaultIsDynamic: !1
  }) : d;
}
function ns(e, t) {
  return Object.keys(e).filter((r) => t(r)).reduce((r, n) => (r[n] = e[n], r), {});
}
function as(e) {
  return ns(e, (t) => !t.startsWith("hook:"));
}
function os(e) {
  if (Object.getOwnPropertyNames(e || {}).length) {
    const t = this.$emit;
    this.$emit = function(...r) {
      var i;
      t.apply(this, r);
      const [n, ...a] = r;
      (i = e[n]) == null || i.apply(this, a);
    };
  }
}
function it(e) {
  const t = Array.from(H(e));
  return t[0] = t[0].toUpperCase(), t.unshift("o", "n"), t.join("");
}
function ss(e, {
  props: t = [],
  camelizePropNames: r = !1
} = {}) {
  const n = {
    props: {},
    attrs: {},
    listeners: {},
    hooks: {},
    slots: {}
  };
  let a;
  if (Array.isArray(t))
    a = r ? t.map((i) => H(i)) : t;
  else if (r) {
    a = [];
    for (const i in t)
      a.push(H(i));
  } else
    a = Object.keys(t);
  for (const i in e)
    if (i.startsWith("@")) {
      const o = i.substring(1);
      if (Dt)
        if (o.startsWith("vue:"))
          n.hooks[it(o.replace("vue:", "vnode-"))] = e[i];
        else {
          if (o.startsWith("vnode"))
            throw new Error("@vnode-* hooks are no longer supported. Use the vue: prefix instead. For example, @vnode-mounted should be changed to @vue:mounted. @vnode-* hooks support has been removed in Vue 3.4.");
          n.listeners[it(o)] = e[i];
        }
      else
        o.startsWith("hook:") ? n.hooks[o] = e[i] : n.listeners[o] = e[i];
    } else if (i.startsWith("#")) {
      const o = i.substring(1);
      o && (n.slots[o] = e[i]);
    } else {
      const o = r ? H(i) : i;
      a.includes(o) ? n.props[o] = e[i] : n.attrs[i] = e[i];
    }
  return n;
}
export {
  rs as conclude,
  as as getLocalListeners,
  os as listenGlobalHooks,
  ss as resolveConfig
};
//# sourceMappingURL=vue-global-config.mjs.map
